export default __webpack_public_path__ + "3400050c657d9dcc8f9be4638fc021bf.svg";